export enum TaskLocationStatus {
  NOT_STARTED = 'not-started',
  IN_PROGRESS = 'in-progress',
  STOPPED = 'stopped',
  DONE = 'done'
}
